import React, { useContext, useEffect, useState } from 'react';
import '../styles/basketItemDiscount.css';
import '../styles/summary.css';
import { X } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromRemovableCoupons } from '../store/couponsSlice';
import { loaderActions } from '../store/loaderSlice';
import appConst from '../Utilities/appConst.json';
import IconButton from '../shared/IconButton';

export default function RemovableCoupon(props) {
    const dispatch = useDispatch();
    const basket = useSelector(state => state.basket.basket);
    const direction = useSelector((state) => state.mode.direction);
    const isRtl = direction === "rtl";
    const [shouldDelete, setShouldDelete] = useState(false);
    const isSrtviceCoupon = props.removableCoupon.coupon_class === appConst.SERVICE_CODE_CLASS;
    const discount = isSrtviceCoupon ? null : `-(₪${parseFloat(props.removableCoupon.stand_alone_value).toFixed(2)})`;
    const message = props.removableCoupon.message;
    const title = isSrtviceCoupon
      ? props.removableCoupon.title
      : `${props.removableCoupon.title}:`;

    useEffect(() => {
        if (shouldDelete) {
            dispatch(loaderActions.loaderShow());
            dispatch(removeFromRemovableCoupons(props.removableCoupon, basket));
            setShouldDelete(false);
        }
    }, [basket.delivery_details.delivery_type]);

    const hendleOnClick = () => {
        dispatch(loaderActions.loaderShow());
        dispatch(removeFromRemovableCoupons(props.removableCoupon, basket));
    }

    return (
        <div
          className='content_selected_coupon'
          style={{ flexDirection: isRtl ? "row-reverse" : "row" }}
          data-testid="summary-removable-coupon"
        >
            <div className='box_item_l amount_ltr'>{discount}</div>
            <div className="summary_removable_coupon_and_icon" style={{ flexDirection: isRtl ? "row-reverse" : "row", gap: "6px" }}>
                <div className="summary_coupon_text" dir="auto">
                    <div className='box_item_r bold'>
                        {title}
                    </div>
                    <div className='box_item_l'>
                        {message}
                    </div>
                </div>
                <IconButton
                    className="summary-icon-btn p-0"
                    data-testid={`summary-coupon-remove-${props.removableCoupon?.coupon_id ?? "unknown"}`}
                    onClick={hendleOnClick}
                >
                    <X size={20} />
                </IconButton>
            </div>
        </div>
    )
}
